import { useState } from "react";

import NpsHeader from "./NpsHeader.tsx";
// import NpsTopBanner from "./NpsTopBanner";
import NpsTabs from "./NpsTabs.tsx";
import OverviewContent from "./OverviewContent/OverviewContent.tsx";

import ContributionsTab from "./tabs/ContributionsTab.tsx";
import NavPerformanceTab from "./tabs/NavPerformanceTab.tsx";
import StatementsTab from "./tabs/StatementsTab.tsx";
import AnalyticsTab from "./tabs/AnalyticsTab.tsx";
import WithdrawalTab from "./tabs/WithdrawalTab.tsx";
import { useRegistrationDetails } from "../../context/registrationDetails.tsx";

const NpsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState("Overview");

  const { registrationDetails } = useRegistrationDetails();

  return (
    <div className="min-h-screen space-y-6 bg-gray-50 p-4 md:p-8">
      {/* Header */}
      <NpsHeader registrationDetails={registrationDetails} />

      {/* Banner */}
      {/* <NpsTopBanner /> */}

      {/* Tabs */}
      <NpsTabs activeTab={activeTab} onChange={setActiveTab} />

      {/* CONTENT SWITCHER */}
      {activeTab === "Overview" && (
        <OverviewContent registrationDetails={registrationDetails} />
      )}
      {activeTab === "Contributions" && (
        <ContributionsTab registrationDetails={registrationDetails ?? null} />
      )}
      {activeTab === "NAV & Performance" && (
        <NavPerformanceTab registrationDetails={registrationDetails} />
      )}
      {activeTab === "Statements" && <StatementsTab />}
      {activeTab === "Analytics" && <AnalyticsTab />}
      {activeTab === "Withdrawal" && <WithdrawalTab />}
    </div>
  );
};

export default NpsPage;
